import { Dialog } from '../../../../widgets/dialog';
import { PrimaryButton } from '../../../../widgets/buttons';
import { showErrorNotification, showSuccessNotification } from '../../../../widgets/notificationToaster';
import React, { FC, useCallback, useState } from 'react';
import { useMutation } from 'react-relay';
import { T } from 'src/shared/helpers';
import { notifyFairUseLimitReachedMutation } from '../../queries/__generated__/notifyFairUseLimitReachedMutation.graphql';
import { NotifyFairUseLimitReachedMutation } from '../../queries/notifyFairUseLimitReached';
import { DialogContent, DialogFooter } from '../shared/sharedStyles';

interface FairUseLimitDialogProps {
    serviceName: string;
    onClose: () => void;
}

export const FairUseLimitDialog: FC<FairUseLimitDialogProps> = ({ serviceName, onClose }) => {
    const [sent, setSent] = useState(false);
    const [sendNotification, isInFlight] = useMutation<notifyFairUseLimitReachedMutation>(NotifyFairUseLimitReachedMutation);

    const handleSend = useCallback(
        (serviceName: string) => {
            sendNotification({
                variables: { serviceName },
                onCompleted: () => {
                    setSent(true);
                    showSuccessNotification({ message: T._('Your message has been sent to help@zakeke.com.', 'Admin') });
                    onClose();
                },
                onError: () => {
                    showErrorNotification({ message: T._('Failed to send the notification. Please try again.', 'Admin') });
                }
            });
        },
        [sendNotification, onClose]
    );

    return (
        <Dialog title={T._('Unlock Unlimited AI Studio Agents', 'Admin')} onClose={onClose}>
            <DialogContent>
                <p style={{ margin: 0 }}>
                    {T._('Your free usage has ended, but you can continue using AI Studio Agents to support your workflow and automation.', 'Admin')}
                    <br />
                    {T._('To keep using advanced AI capabilities without interruptions, reach out to us.', 'Admin')}
                    <br />
                    {T._('Click below to send us a message. We will get back to you shortly.', 'Admin')}
                </p>
                <DialogFooter>
                    <PrimaryButton onClick={() => handleSend(serviceName)} disabled={isInFlight || sent}>
                        {isInFlight ? T._('Sending request', 'Admin') + '...' : T._('Request continuation', 'Admin')}
                    </PrimaryButton>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
